import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "menu", "status", "revertSection"]
  static values = {
    url: String,
    textarea: String
  }

  connect() {
    this.originalText = null
    this.isOpen = false

    // Close menu on outside click
    this.outsideClickHandler = (event) => {
      if (!this.element.contains(event.target) && this.isOpen) {
        this.closeMenu()
      }
    }
    document.addEventListener("click", this.outsideClickHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler)
  }

  toggleMenu() {
    this.isOpen ? this.closeMenu() : this.openMenu()
  }

  openMenu() {
    this.menuTarget.classList.remove("hidden")
    this.isOpen = true
  }

  closeMenu() {
    this.menuTarget.classList.add("hidden")
    this.isOpen = false
  }

  async enhance(event) {
    const mode = event.currentTarget.dataset.mode
    const textarea = document.querySelector(this.textareaValue)

    if (!textarea) {
      console.error("Script enhancer: textarea not found:", this.textareaValue)
      return
    }

    const text = textarea.value.trim()
    if (!text) return

    // Store original for revert
    if (!this.originalText) {
      this.originalText = text
    }

    this.closeMenu()
    this.showLoading()

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ text, mode })
      })

      const data = await response.json()

      if (data.success) {
        textarea.value = data.enhanced_text
        // Trigger input event for any listeners
        textarea.dispatchEvent(new Event("input", { bubbles: true }))
        this.showRevert()
      } else {
        this.showError(data.error || "Enhancement failed")
      }
    } catch (error) {
      this.showError("Network error. Please try again.")
    } finally {
      this.hideLoading()
    }
  }

  revert() {
    if (!this.originalText) return

    const textarea = document.querySelector(this.textareaValue)
    if (textarea) {
      textarea.value = this.originalText
      textarea.dispatchEvent(new Event("input", { bubbles: true }))
    }

    this.originalText = null
    this.hideRevert()
    this.closeMenu()
  }

  showLoading() {
    this.statusTarget.classList.remove("hidden")
    this.triggerTarget.disabled = true
    this.triggerTarget.classList.add("opacity-50")
  }

  hideLoading() {
    this.statusTarget.classList.add("hidden")
    this.triggerTarget.disabled = false
    this.triggerTarget.classList.remove("opacity-50")
  }

  showRevert() {
    this.revertSectionTarget.classList.remove("hidden")
  }

  hideRevert() {
    this.revertSectionTarget.classList.add("hidden")
  }

  showError(message) {
    this.statusTarget.classList.remove("hidden")
    this.statusTarget.innerHTML = `<span class="text-red-600">${message}</span>`
    setTimeout(() => this.statusTarget.classList.add("hidden"), 3000)
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }
}
